// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const deoxys_normal: PokeData = {
  "id": 386,
  "name": "deoxys-normal",
  "height": 17,
  "weight": 608,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "wrap",
    "leer",
    "hyper-beam",
    "psychic",
    "teleport",
    "night-shade",
    "recover",
    "pursuit",
    "knock-off",
    "skill-swap",
    "snatch",
    "cosmic-power",
    "psycho-boost",
    "gravity",
    "psycho-shift",
    "zen-headbutt",
    "psyshock"
  ],
  "moves": [
    "leer",
    "psychic",
    "night-shade",
    "pursuit",
    "snatch",
    "zen-headbutt",
    "synchronize",
    "psy-pulse",
    "psy-ball",
    "calm-mind",
    "psychic-terrain",
    "reflect",
    "prismatic-cage"
  ],
  "evolution_chain": {
    "id": 202,
    "item": null,
    "species": [
      {
        "name": "deoxys",
        "order": 416,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 57,
    "speed": 171,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
